export default __webpack_public_path__ + "static/media/placeholder_business01-jp-web.023b189a.png";